import _get from 'lodash.get';

function get(obj, path) {
    return _get(obj, path);
}

export { get };
